import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filterPages'
})
export class PagesFilter implements PipeTransform {

    transform(pagesArray: any[], category?: string, searchText?: string) {
        if (!pagesArray) { return null; }

        let finalArray = [...pagesArray];

        if (category && category !== '0') {
            finalArray = finalArray.filter(page => (<string>page.pageCategoryName).toLowerCase() === category.toLowerCase());
        }
        if(searchText && searchText.length > 0){
            finalArray = finalArray.filter(page => (<string>page.name).toLowerCase().includes(searchText.toLowerCase()))
        }

        return finalArray;
    }

}